import React, {useState} from 'react';
import {View, Text, TouchableOpacity, Switch, ActivityIndicator} from 'react-native';
import I18n from 'i18n-js';
import {useDispatch, useSelector} from 'react-redux';
import {UpdateScanPackSettings} from '../../actions/userAction';
import {
  selectScanPackSettings,
  selectCanEditScanningPrefs
} from '../../selectors/scanPackSelectors';
import Toast, {useToast} from '../../commons/Toast';
import {AntDesign} from '@expo/vector-icons';
import ToolTip from '../directPrinting/toolTip';
import directPrintingStyles from '../../style/directPrinting';
import {styles as scanPackStyles} from './styles';
import useWidth from '../scanToCartScanning/useWidth';

const ScanPackSettingToggle = ({
  settingKey,
  labelKey,
  tooltipKey,
  testID,
  activeTollTip,
  handleTollTip,
  activeTollTipValue = 'includeActionRequiredOrdersTooltip'
}) => {
  const windowWidth = useWidth();
  const isActiveTooltip = activeTollTip === activeTollTipValue;

  const containerStyle =
    windowWidth > 900
      ? [scanPackStyles.scanPackToggleContainer, scanPackStyles.scanPackToggleContainerDesktop]
      : [scanPackStyles.scanPackToggleContainer, scanPackStyles.scanPackToggleContainerMobile];
  const dispatch = useDispatch();
  const scanPackSettings = useSelector(selectScanPackSettings);
  const canEditScanningPrefs = useSelector(selectCanEditScanningPrefs);
  const [isUpdating, setIsUpdating] = useState(false);
  const {showToast, toastMessage, showToastMessage, hideToast} = useToast();

  const handleToggle = (value) => {
    if (!scanPackSettings || isUpdating || !canEditScanningPrefs) return;

    let actualSettings = scanPackSettings;
    if (scanPackSettings?.data) {
      actualSettings = scanPackSettings.data;
    }
    const payload = {...actualSettings};
    if (payload?.settings) {
      const {...nestedSettings} = payload.settings;
      Object.assign(payload, nestedSettings);
      delete payload.settings;
    }
    payload[settingKey] = value;

    setIsUpdating(true);

    const onComplete = (result) => {
      setIsUpdating(false);
      if (result && result.success === false) {
        showToastMessage(
          result.errorMessages?.[0] || I18n.t('scanPack.settingUpdateFailed')
        );
      }
    };

    dispatch(UpdateScanPackSettings(payload, onComplete));
  };

  const currentValue = scanPackSettings?.[settingKey] || false;

  return (
    <View style={containerStyle}>
      <View style={scanPackStyles.scanPackToggleRow}>
        <TouchableOpacity
          style={scanPackStyles.scanPackToggleInfoButton}
          testID={testID}
          onPress={() => handleTollTip(activeTollTipValue)}>
          <i className="icon-info-circled" style={directPrintingStyles.iconInfo}></i>
        </TouchableOpacity>
        {isUpdating ? (
          <ActivityIndicator size="small" color="#fff" />
        ) : (
          <Switch
            testID={testID}
            disabled={isUpdating || !canEditScanningPrefs}
            onValueChange={handleToggle}
            offColor="#5c6e79"
            onColor="#65baea"
            offHandleColor="#969696"
            onHandleColor="#fbfdfe"
            handleDiameter={22}
            uncheckedIcon={false}
            checkedIcon={false}
            height={20}
            width={40}
            value={currentValue}
          />
        )}
        {!canEditScanningPrefs && (
          <AntDesign
            testID={`${testID}LockIcon`}
            name="lock"
            size={16}
            color="#fff"
          />
        )}
        <Text style={scanPackStyles.scanPackToggleLabel}>
          {I18n.t(labelKey)}
        </Text>
        {isActiveTooltip && (
          <ToolTip
            message={I18n.t(tooltipKey)}
            testID={`${testID}Tooltip`}
            windowWidth={windowWidth}
            left="-54%"
            top={15}
            bodyTop={-50}
            style={scanPackStyles.scanPackTooltip}
          />
        )}
      </View>
      <Toast
        visible={showToast}
        message={toastMessage}
        onHide={hideToast}
        colors={['#d40202', '#e53935']}
        textColor="#fff"
      />
    </View>
  );
};

export default ScanPackSettingToggle;
